<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết TPV thiết bị của MC</h1>
      <div class="btn-group float-right">
        <button class="f12 font-medium btn btn-outline-secondary" @click="backToList()">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="ttc">
              <div class="form-row">
                <div class="form-detail col-6">
                  <h1>Thông tin TPV thiết bị của MC</h1>

                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label f14"
                      >Email MC: <span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f14">{{ $route.params.email }}</p>
                    </div>
                  </div>
                  <div class="form-group form-row">
                    <label for="" class="col-sm-2 col-form-label f14"
                      >Ngày giao dịch: <span class="float-right">:</span></label
                    >
                    <div class="col-sm-10">
                      <p class="form-control-plaintext f14">{{ $route.params.date }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-detail">
                  <div class="d-flex justify-content-between">
                    <h1>Thiết bị của MC</h1>
                  </div>
                  <div class="table-responsive">
                    <table
                      class="table table-hover table-bordered"
                      style="max-height: 400px; overflow-y: auto"
                    >
                      <thead class="thead-light">
                        <tr>
                          <th scope="col" class="text-center">Serial</th>
                          <th scope="col" class="text-center">Thời gian</th>
                          <th scope="col" class="text-center">Trạng thái giao dịch</th>
                          <th scope="col" class="text-center">TPV</th>
                          <th scope="col" class="text-center">Loại giao dịch</th>
                          <th scope="col" class="text-center">Thao tác</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          class="table-row"
                          v-for="(item, index) in detail.deviceInfos"
                          :key="index"
                        >
                          <td class="text-center">
                            {{ item.serial }}
                          </td>
                          <td class="text-center">
                            {{ item.date }}
                          </td>
                          <td class="text-center">
                            {{ item.statusTransaction }}
                          </td>
                          <td class="text-center">
                            {{ item.tpv }}
                          </td>
                          <td class="text-center">
                            {{ item.typeTransaction }}
                          </td>
                          <td class="text-center">
                            <b-dropdown class="text-center" variant="outline-light">
                              <b-dropdown-item class="dropdown-item"
                                ><span>&nbsp;</span>Chi tiết
                              </b-dropdown-item>
                            </b-dropdown>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>
<script>
  import { NotificationService } from '@/services/notification.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'

  export default {
    name: 'warranty-detail',
    data() {
      return {
        Config,
        showLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')) ?? {},
        id: this.$route.params.id,
        detail: {},
        deviceHistory: [],
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    created() {
      this.fetchData()
    },

    methods: {
      backToList() {
        this.$router.push('/tpv')
      },
      async fetchData() {
        try {
          this.showLoading = true
          const data = await NotificationService.detailTPV({
            dateTransaction: this.$route.params.date,
            merchantEmail: this.$route.params.email,
          })
          if (data.success || data.code === 1000) {
            this.detail = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped></style>
